import React, { useState, useEffect, useRef } from 'react';
import ImageViewer from './ImageViewer';
import Sidebar from './Sidebar';
import ToolBar from './ToolBar';
import './StudyViewer.css';

const StudyViewer = ({ study }) => {

  const [studyData, setStudyData] = useState(null);
  const [layout, setLayout] = useState('1x1');
  const [showContextAwareSidebar, setShowContextAwareSidebar] = useState(true);
  const [currentImageInfo, setCurrentImageInfo] = useState(null);
  const imageViewerRef = useRef(null);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {

    if (!study) {
      return;
    }

    // Load study data from backend
    const loadStudy = async () => {
      try {

        const response = await fetch(`${BACKEND_URL}/api/studies/${study.patientId}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch study: ${response.statusText}`);
        }
        const data = await response.json();
        setStudyData(data);
        console.log('Study successfully fetched from backend: ', data);
      } catch (err) {
        const errorMsg = err instanceof Error ? err.message : 'Unknown error';
        console.error('Error fetching study:', errorMsg);
      }
    };

    loadStudy();
  }, [BACKEND_URL, study]);

  const handleLayoutChange = (newLayout) => {
    setLayout(newLayout);
  };

  const handleImageChange = (imageInfo) => {
    setCurrentImageInfo(imageInfo);
  };

  const handleAcceptAnnotations = (findingsData) => {
    if (imageViewerRef.current) {
      imageViewerRef.current.drawAnnotations(findingsData);
    }
  };

  if (!study) {
    return null;
  }

  return (
    <div className="study-viewer">
      <div className="study-viewer-container">
        <ToolBar onLayoutChange={handleLayoutChange} />

        <ImageViewer
          ref={imageViewerRef}
          studyData={studyData}
          patientId={study.patientId}
          imageInfo={currentImageInfo}
          modality={study.modality}
          layout={layout}
          onImageChange={handleImageChange}
        />

      </div>

      {showContextAwareSidebar && (
        <Sidebar
          patientId={study.patientId}
          studyData={studyData}
          imageInfo={currentImageInfo}
          isVisible={showContextAwareSidebar}
          onToggle={() => setShowContextAwareSidebar(!showContextAwareSidebar)}
          onAcceptAnnotations={handleAcceptAnnotations}
        />
      )}
    </div>
  );
};

export default StudyViewer;
